"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDisplay = toDisplay;
const Format_1 = require("../Format");
const Kind_1 = require("../Kind");
const formatCharge_js_1 = require("./formatCharge.js");
/**
 * Converts an array of mf elements to an array of formatting information
 * @param {object[]} lines of the parse method
 * @returns {{kind: string, value: string}[]}
 */
function toDisplay(lines) {
    let results = [];
    let result = {};
    for (let line of lines) {
        switch (line.kind) {
            case Kind_1.Kind.MULTIPLIER:
                if (line.value !== 1) {
                    result = {
                        kind: Format_1.Format.SUBSCRIPT,
                        value: String(line.value),
                    };
                    results.push(result);
                }
                break;
            case Kind_1.Kind.MULTIPLIER_RANGE:
                result = {
                    kind: Format_1.Format.SUBSCRIPT,
                    value: `${String(line.value.from)}-${line.value.to}`,
                };
                results.push(result);
                break;
            case Kind_1.Kind.CHARGE:
                if (result.kind === Format_1.Format.SUBSCRIPT) {
                    result.kind = Format_1.Format.SUPERIMPOSE;
                    result.over = (0, formatCharge_js_1.formatCharge)(line.value);
                    result.under = result.value;
                    result.value = undefined;
                }
                else {
                    result = {
                        kind: Format_1.Format.SUPERSCRIPT,
                        value: (0, formatCharge_js_1.formatCharge)(line.value),
                    };
                    results.push(result);
                }
                break;
            case Kind_1.Kind.ISOTOPE:
                result = {
                    kind: Format_1.Format.SUPERSCRIPT,
                    value: line.value.isotope,
                };
                results.push(result);
                result = {
                    kind: Format_1.Format.TEXT,
                    value: line.value.atom,
                };
                results.push(result);
                break;
            case Kind_1.Kind.ISOTOPE_RATIO:
                if (result.kind === Format_1.Format.TEXT) {
                    result.value += line.value.atom;
                }
                else {
                    result = {
                        kind: Format_1.Format.TEXT,
                        value: line.value.atom,
                    };
                    results.push(result);
                }
                result = {
                    kind: Format_1.Format.SUPERSCRIPT,
                    value: `{${line.value.ratio.join(',')}}`,
                };
                results.push(result);
                break;
            case Kind_1.Kind.SALT:
                if (result.kind === Format_1.Format.TEXT) {
                    result.value += ' • ';
                }
                else {
                    result = {
                        kind: Format_1.Format.TEXT,
                        value: ' • ',
                    };
                    results.push(result);
                }
                break;
            default:
                if (result.kind === Format_1.Format.TEXT) {
                    result.value += line.value;
                }
                else {
                    result = {
                        kind: Format_1.Format.TEXT,
                        value: line.value,
                    };
                    results.push(result);
                }
        }
    }
    return results;
}
//# sourceMappingURL=toDisplay.js.map